const convertOptions = (text, value, key) => {
  return {
    text: text,
    value: value,
    key: key,
  };
};

export default convertOptions;
